// extracted by mini-css-extract-plugin
export default {"about":"AboutPage_about__aP+Dr","about__title":"AboutPage_about__title__9vMXB","segmented":"AboutPage_segmented__sxplD","segmented__item":"AboutPage_segmented__item__ti35M"};